//Image Component Constants

// export const CLASSROOM_URL = "/training/classroom";
// export const WEBINAR_URL = "/training/webinar";
// export const SEMINAR_URL = "/training/seminar";
// export const E_LEARNING_URL = "/training/complimentary";

export const CLASSROOM_URL = "/training/search?ds%5B0%5D=ByFormat%7CClassroom";
export const WEBINAR_URL = "/training/search?ds%5B0%5D=ByFormat%7CWebinar";
export const SEMINAR_URL = "/training/search?ds%5B0%5D=ByFormat%7CSeminar";
export const E_LEARNING_URL = "/training/search?ds%5B0%5D=ByFormat%7CComplimentary";